$(document).ready(function () {
    var externalLinkHandler = function () {
        var currentDomain =  window.location.origin;
        var externalLinks = $('a[href^="http"]:not(a[href^="'+ currentDomain + '"]), a[href$=".pdf"]');
        externalLinks.each(function (index, element) {
            // neos widget link bug which generates absolute urls
            if($(element).parents('.neos-widget-paginator').length === 0) {
                $(element).attr('target', '_blank');
            }
        });
    };

    // init
    externalLinkHandler();
});